if (!customElements.get('mount-information')) {
  customElements.define(
    'mount-information',
    class MountInformation extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.onOptionChange = this.onOptionChange.bind(this);
        this.productInfo?.addEventListener('change', this.onOptionChange);
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onOptionChange);
      }

      onOptionChange(event) {
        if (!event.target.closest('variant-selects')) return;

        window.requestAnimationFrame(() => this.updateVisibility());
      }

      updateVisibility() {
        const frameOptionName = this.dataset.frameOptionName?.trim().toLowerCase();
        const variantSelects = this.productInfo?.querySelector('variant-selects');

        if (!frameOptionName || !variantSelects) {
          this.classList.remove('is-visible');
          return;
        }

        const controls = variantSelects.querySelectorAll('select, input[type="radio"]:checked');
        const frameControl = Array.from(controls).find((control) => {
          const optionName =
            control.dataset.optionName ||
            control.selectedOptions?.[0]?.dataset.optionName ||
            control.name?.match(/^options\[(.*)\]$/)?.[1];

          return optionName?.trim().toLowerCase() === frameOptionName;
        });

        const frameValue = frameControl?.value?.trim().toLowerCase();
        this.classList.toggle('is-visible', ['print only', 'no frame'].includes(frameValue));
      }
    }
  );
}
